import React from 'react';
import { Container, Row, Col, Button, Card, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../styles/social/LandingPage.css'; // Criaremos este arquivo a seguir
import logoImage from '../img/logo.png';
import featureImage1 from '../img/placeholder-agenda.png'; // Substitua pela sua imagem
import featureImage2 from '../img/placeholder-financeiro.png'; // Substitua pela sua imagem
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck, faChartPie, faBoxesStacked, faFileMedical, faInfinity, faUsers, faBoxOpen, faCheck, faStethoscope, faConciergeBell, faUserShield } from '@fortawesome/free-solid-svg-icons';

const LandingPage = () => {
    // Lista de funcionalidades principais para a seção "Features"
    const features = [
        {
            icon: faCalendarCheck,
            title: 'Agenda Inteligente e Prontuário Eletrônico',
            description: [
                'Organize os agendamentos de múltiplos profissionais, com visualização por dia, semana ou mês.',
                'Acesse o prontuário completo do paciente com um clique, registrando histórico, fotos e evoluções.',
                'O perfil Recepção consegue visualizar as agendas de todos os médicos.',
                'O Médico pode atender os pacientes por horário marcado',
                'Pode também visualizar os pacientes por ordem de chegada.',
                'Envie comunicados para seus pacientes',
                'Ferramenta inteligente para envio de comunicados para aniversariantes, pacientes sem retenção',
                'Envio de comunicados para pacientes com interesses em comum'
            ],
            mediaType: 'image',
            textFirst: true,
            mediaUrl: featureImage1, // Usando a imagem importada
        },
        {
            icon: faChartPie,
            title: 'Gestão Financeira Completa',
            description: [
                'Acompanhe o faturamento dos últimos 7 e 30 dias, além do dia atual.',
                'Analise faturamentos detalhados por serviços, pacientes e períodos.',
                'Gere relatórios de pagamentos recebidos, pendentes, inadimplência e por forma de pagamento.',
                'Obtenha insights com Ticket Médio por paciente e Taxa de Retenção.',
                'Realize uma análise completa de custos e despesas para otimizar seus resultados.'
            ],
            mediaType: 'image',
            mediaUrl: featureImage2, // Usando a imagem importada
            textFirst: false,
        },
        {
            icon: faBoxesStacked,
            title: 'Controle de Estoque Integrado',
            description: 'Monitore a entrada e saída de materiais automaticamente a cada serviço realizado. Receba alertas de estoque baixo e evite desperdícios ou falta de insumos. Há a possibilidade de controlar o estoque manualmente também, onde só os perfis que tiverem a permissão poderão realizar o ajuste.',
            mediaType: 'video',
            mediaUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', // Substitua pela URL do seu vídeo
            textFirst: true,
        },
        {
            icon: faUserShield,
            title: 'Segurança e Perfis de Acesso',
            description: 'Com o Fluxo Clínica, vocÊ tem o controle total sobre quem vê o quê. Crie perfis de acesso personalizados (Médico, Recepção, Financeiro) e garanta a segurança e a privacidade dos dados dos seus pacientes e da sua clínica.',
            mediaType: 'video',
            mediaUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', // Substitua pela URL do seu vídeo
            textFirst: false,
        },
        {
            icon: faFileMedical,
            title: 'Personalização e Relatórios',
            description: 'Crie perfis de acesso, personalize tags de interesse para segmentar pacientes e gere relatórios detalhados sobre faturamento, pagamentos e desempenho da clínica.',
            mediaType: 'video',
            mediaUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', // Substitua pela URL do seu vídeo
            textFirst: false,
        },
    ];

    // Lista de módulos para a seção "Hero"
    const modules = [
        { icon: faStethoscope, name: 'Consultório' },
        { icon: faUsers, name: 'Equipe' },
        { icon: faBoxesStacked, name: 'Estoque' },
        { icon: faConciergeBell, name: 'Serviços' },
        { icon: faChartPie, name: 'Financeiro' },
        { icon: faUserShield, name: 'Perfis de Acesso' },
    ];

    return (
        <div className="landing-page">
            {/* --- Navbar Simples --- */}
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top shadow-sm">
                <Container>
                    <Link className="navbar-brand" to="/inicio">
                        <Image src={logoImage} alt="Logo da Fluxo Clínica" style={{ maxHeight: '40px' }} />
                    </Link>
                    <div>
                        <Link to="/register" className="btn btn-light btn-lg fw-bold">Cadastre-se Grátis</Link>
                    </div>
                </Container>
            </nav>

            {/* --- Seção Principal (Hero) --- */}
            <header className="hero-section text-center">
                <Container>
                    <h1 className="display-4 fw-bold" style={{ color: 'darkgreen' }}>A Gestão da Sua Clínica, Simplificada com todos os Módulos</h1>
                    <p className="lead my-4" >
                        Sem mensalidades no plano Gratuito, Sem limite de profissionais e com todos os módulos liberados para sempre, com controle de perfil para que possa controlar quem pode ver o que!
                        <br />
                        Otimize seu tempo e foque no que realmente importa: seus pacientes.
                    </p>

                    <div className="my-5">
                        <h4 className="mb-4 fw-normal" style={{ color: 'darkgreen' }}>Módulos Inclusos</h4>
                        <Row className="justify-content-center g-4">
                            {modules.map((module, index) => (
                                <Col key={index} xs="auto" md={2} className="text-center">
                                    <FontAwesomeIcon icon={module.icon} size="2x" className="mb-2" aria-hidden="true" />
                                    <p className="mb-0">{module.name}</p>
                                </Col>
                            ))}
                        </Row>
                    </div>

                    <Link to="/register" className="btn btn-success btn-lg fw-bold">Comece a Usar Agora - É Grátis!</Link>
                </Container>
            </header>

            {/* --- Seção de Funcionalidades --- */}
            <section className="features-section pt-3 pb-5">
                <Container>
                    <h2 className="text-center mb-5 section-title" style={{ color: 'darkgreen' }}>Funcionalidades Poderosas para o seu Dia a Dia</h2>
                    {features.map((feature, index) => (
                        <Row key={index} className="align-items-center feature-row mb-5">
                            <Col md={6} className={`${feature.textFirst ? 'order-md-2' : 'order-md-1 d-flex justify-content-center'}`}>
                                {feature.mediaType === 'video' ? (
                                    <div className="video-container rounded">
                                        <iframe
                                            src={feature.mediaUrl}
                                            title={feature.title}
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                ) : (
                                    <div className="image-container rounded">
                                        <Image src={feature.mediaUrl} alt={feature.title} fluid rounded />
                                    </div>
                                )}
                            </Col>
                            <Col md={6} className={feature.textFirst ? 'order-md-1' : 'order-md-2'}>
                                <div className={`p-md-5 ${feature.textFirst ? 'pe-md-0' : 'ps-md-0'}`}>
                                    <h4 style={{ color: 'darkgreen' }}>
                                        <FontAwesomeIcon icon={feature.icon} className="text-primary me-3" aria-hidden="true" />
                                        {feature.title}
                                    </h4>
                                    {Array.isArray(feature.description) ? (
                                        <ul className="text-muted ps-0" style={{ listStyle: 'none' }}>
                                            {feature.description.map((item, i) => (
                                                <li key={i} className="mb-2 d-flex align-items-start">
                                                    <FontAwesomeIcon icon={faCheck} className="text-success me-2 mt-1" style={{ width: '1.2em' }} aria-hidden="true" />
                                                    <span>{item}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p className="text-muted">{feature.description}</p>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    ))}
                </Container>
            </section>

            {/* --- Seção de Preço (Grátis) --- */}
            <section className="pricing-section py-5 bg-light">
                <Container className="text-center">
                    <h2 className="mb-4 section-title" style={{ color: 'darkgreen' }}>Todos os módulos liberados, com quantos profissionais que quiser cadastrar. Sem Surpresas.</h2>
                    <p className="lead text-muted mb-5">
                        Acreditamos que a tecnologia para gestão de saúde deve ser acessível a todos. Por isso, nosso sistema é 100% pensado nisso.
                    </p>
                    <Row>
                        <Col md={4} className="mb-4">
                            <Card className="h-100 shadow-sm border-0">
                                <Card.Body className="p-4">
                                    <div className="pricing-icon mb-3">
                                        <FontAwesomeIcon icon={faInfinity} size="3x" className="text-success" aria-hidden="true" />
                                    </div>
                                    <Card.Title as="h4" style={{ color: 'darkgreen' }}>Período de teste</Card.Title>
                                    <Card.Text className="text-muted">
                                        Use todas as funcionalidades sem pagar nada, liberamos 200 agendamentos para utilizar da melhor forma. Sem taxas, sem pegadinhas, se gostar poderá escolher um plano que melhor lhe atende.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} className="mb-4">
                            <Card className="h-100 shadow-sm border-0">
                                <Card.Body className="p-4">
                                    <div className="pricing-icon mb-3">
                                        <FontAwesomeIcon icon={faUsers} size="3x" className="text-success" aria-hidden="true" />
                                    </div>
                                    <Card.Title as="h4" style={{ color: 'darkgreen' }}>Pacientes Ilimitados</Card.Title>
                                    <Card.Text className="text-muted">
                                        Cadastre quantos pacientes, recepcionistas e outros colaboradores precisar, sem custo adicional.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} className="mb-4">
                            <Card className="h-100 shadow-sm border-0">
                                <Card.Body className="p-4">
                                    <div className="pricing-icon mb-3">
                                        <FontAwesomeIcon icon={faBoxOpen} size="3x" className="text-success" aria-hidden="true" />
                                    </div>
                                    <Card.Title as="h4" style={{ color: 'darkgreen' }}>Todos os Módulos Inclusos</Card.Title>
                                    <Card.Text className="text-muted">
                                        Acesso completo à agenda, prontuário, financeiro, estoque e todas as futuras atualizações.
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* --- Seção de Chamada para Ação (CTA) --- */}
            <section className="cta-section text-center text-white py-5">
                <Container>
                    <h2 className="fw-bold" >Pronto para transformar a gestão da sua clínica?</h2>
                    <p className="lead my-4">Junte-se a centenas de profissionais que já estão otimizando seu trabalho.</p>
                    <p className="fw-light mb-4">Cadastro rápido e acesso imediato.</p>
                    <Link to="/register" className="btn btn-light btn-lg fw-bold">
                        Crie sua conta gratuita agora!
                    </Link>
                </Container>
            </section>

            {/* --- Rodapé --- */}
            <footer className="footer-section text-center py-4">
                <Container>
                    <p className="text-muted mb-0">&copy; {new Date().getFullYear()} Fluxo Clínica. Todos os direitos reservados.</p>
                </Container>
            </footer>
        </div>
    );
};

export default LandingPage;